import React, { ForwardedRef, useEffect, useRef } from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css'; // 引入 Video.js 样式
import Player from 'video.js/dist/types/player';
import styled from 'styled-components';
import { useUpdateEffect } from 'ahooks';
import { $height, $width } from '@/assets/styles/mediaSize';

interface IvideoPlayerProps {
  src: string;
}

const VideoPlayerWrap = styled.div`
  width: 100%;
  height: 100%;
  background-color: black;
  position: relative;

  .icon-pause-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    ${$width('110rem', '80rem')}
    ${$height('110rem', '80rem')}
    transform: translate(-50%, -50%);
    z-index: 7;
  }

  .video-tool {
    position: absolute;
    bottom: 143rem;
    color: #fff;
    font-size: 20rem;
    font-weight: bold;
    z-index: 9;

    &.video-time {
      left: 32rem;
    }

    &.video-speed {
      right: 32rem;
    }
  }

  .video-js {
    width: 100%;
    height: 100%;
  }

  .mask-click {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 8;
    background-color: transparent;
  }

  .video-js .vjs-big-play-button {
    display: none;
  }

  .video-js .vjs-control-bar {
    background-color: transparent;
    z-index: 9;
  }

  .video-js .vjs-play-progress {
    background: #fff;
  }

  .video-js .vjs-load-progress {
    background: #272727;
  }

  .video-js .vjs-slider-bar {
  }

  .vjs-playback-rate {
  }

  .vjs-volume-panel {
    display: none;
  }

  .vjs-play-control {
    display: none;
  }

  .vjs-picture-in-picture-control {
    display: none;
  }

  .vjs-remaining-time {
    display: none;
  }

  .vjs-progress-control {
    bottom: 82rem;
  }
`;

const formatTime = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
};

const VideoPlayer = forwardRef((props: IvideoPlayerProps, ref: ForwardedRef<any>) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const playerRef = useRef<Player>();
  const timeDisplayRef = useRef<HTMLDivElement | null>(null);
  const [showTime, setShowTime] = useState(false);
  const [isPause, setIsPause] = useState(true);

  useEffect(() => {
    if (!props.src) return;
    let srcObj = {
      key: '',
      url: '',
    };
    try {
      const temp = JSON.parse(props.src);
      // debugger
      srcObj = temp?.resource;
    } catch (error) {
      console.log('解码失败...', error);
    }
    if (!srcObj?.url) {
      return;
    }
    playerRef.current = videojs(videoRef.current!, {
      // controls: true,
      preload: 'auto',
      sources: [
        {
          src: srcObj.url + '#t=0.1',
          type: 'video/mp4',
        },
      ],
      controlBar: {
        fullscreenToggle: false,
      },
      userActions: {
        doubleClick: false,
      },
    });

    if (playerRef.current && timeDisplayRef.current) {
      playerRef.current.on('timeupdate', () => {
        const currentTime = playerRef.current!.currentTime();
        const duration = playerRef.current!.duration();
        const formattedTime: any = `<span>${formatTime(
          currentTime!
        )}</span>/<span style="color: #999">${formatTime(duration!)}</span>`;
        timeDisplayRef.current!.innerHTML = formattedTime;
        setShowTime(formattedTime ? true : false);
      });
    }

    return () => {
      if (playerRef.current) {
        playerRef.current.dispose();
      }
    };
  }, [props.src]);

  const [speed, setSpeed] = useState({
    text: '1x',
    value: 1,
  });

  const pickSpeed = () => {
    if (speed.value === 1) {
      return setSpeed({
        text: '1.5x',
        value: 1.5,
      });
    }
    if (speed.value === 1.5) {
      return setSpeed({
        text: '2x',
        value: 2,
      });
    }
    if (speed.value === 2) {
      return setSpeed({
        text: '1x',
        value: 1,
      });
    }
  };

  useUpdateEffect(() => {
    playerRef.current && playerRef.current.playbackRate(speed.value);
  }, [speed]);

  const togglePlayPause = () => {
    if (playerRef.current) {
      if (playerRef.current.paused()) {
        setIsPause(false);
        playerRef.current.play();
      } else {
        setIsPause(true);
        playerRef.current.pause();
      }
    }
  };

  const resetVideo = () => {
    setSpeed({
      text: '1x',
      value: 1,
    });
    setIsPause(true);
    playerRef.current?.pause();

    setTimeout(() => {
      playerRef.current?.currentTime(0);
    }, 100);
  };

  useImperativeHandle<any, any>(ref, () => ({
    videoRef: videoRef.current,
    resetVideo,
  }));

  return (
    <VideoPlayerWrap>
      <div className="mask-click" onClick={() => togglePlayPause()}></div>
      <div className="video-tool video-time" ref={timeDisplayRef}></div>
      <img
        src={require('@img/chat/icon-video.svg')}
        alt=""
        className={`icon-pause-btn ${isPause ? '' : 'hidden'}`}
      />
      <div
        onClick={() => pickSpeed()}
        className="video-tool video-speed"
        style={{ display: showTime ? 'block' : 'none' }}
      >
        {speed.text}
      </div>
      <video
        ref={videoRef}
        className="video-js"
        controls={false}
        playsInline
        preload="metadata"
      ></video>
    </VideoPlayerWrap>
  );
});

export default VideoPlayer;
